import axios from 'axios'
import { API_URL } from '@/const'
import { store } from '@/store'

export const getAxiosBroadcast = (id, setBroadcast) => {
  const { accessToken } = store.state.app.user
  const headers = {
    Authorization: `Bearer ${accessToken}`
  }
  axios
    .get(`${API_URL.BROADCAST_V1}/${id}`, { headers })
    .then((res) => {
      const { stream_key, name, description, start_time, life, is_anon, owner } = res.data
      setBroadcast(name, description, start_time, life, stream_key, is_anon, owner)
    })
    .catch((err) => console.log(err.response.data))
}
